import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DATA_SELECTOR_INJECTION_TOKEN, SharedModule } from '@aiwyn/shared';
import { CxpDeliverableDetailDataStateService } from '../../services';
import { DeliverableDetailHeaderComponent } from './components/deliverable-detail-header/deliverable-detail-header.component';
import { DeliverableFilesListComponent } from './components/deliverable-files-list/deliverable-files-list.component';
import { DeliverableDetailsSidebarComponent } from './components/deliverable-details-sidebar/deliverable-details-sidebar.component';

@Component({
  selector: 'cxp-deliverable-detail-container',
  templateUrl: './deliverable-detail-container.component.html',
  styleUrls: ['./deliverable-detail-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SharedModule,
    MatProgressBarModule,
    DeliverableDetailHeaderComponent,
    DeliverableFilesListComponent,
    DeliverableDetailsSidebarComponent,
  ],
  providers: [
    {
      provide: DATA_SELECTOR_INJECTION_TOKEN,
      useValue: 'cxp-deliverable-detail',
    },
  ],
})
export class DeliverableDetailContainerComponent {
  private readonly dataState = inject(CxpDeliverableDetailDataStateService);

  protected readonly viewModel = this.dataState.viewModel;
  protected readonly detail = computed(() => this.viewModel().detail);
  protected readonly isLoading = computed(() => this.viewModel().isLoading);
  protected readonly isLoaded = computed(() => this.viewModel().isLoaded);
  protected readonly hasError = computed(() => this.viewModel().hasError);

  constructor() {
    this.dataState.backgroundEffects$().pipe(takeUntilDestroyed()).subscribe({
      error: (err) => console.error('[DeliverableDetailContainer] background effects failed:', err),
    });
  }
}
